import { IconArrowRight } from "@tabler/icons-react";
import classNames from "classnames";
import { JSX, PropsWithoutRef } from "react";
import { Link } from "react-router";
import SectionTag from "~/components/SectionTag";
import IntegrationsWheel from "./IntegrationsWheel";

export type IntegrationsProps = Omit<PropsWithoutRef<JSX.IntrinsicElements["section"]>, "children">;

export default function Integrations({ className, ...props }: IntegrationsProps) {
  return (
    <section {...props} className={classNames("py-16", className)}>
      <div className="container">
        <div className="align-items-center flex-column-reverse flex-lg-row gy-20 row">
          <div className="col-12 col-lg-7">
            <div className="mx-auto mx-lg-0 mw-32rem text-center text-md-start">
              <SectionTag>INTEGRATIONS</SectionTag>

              <h2 className="fs-3 fw-semi-bold lh-base">Your favorite platforms with WebGazer&apos;s simple setup</h2>

              <div className="fs-5 mb-5 mt-8 text-body-secondary">
                <p>
                  Receive notifications through businesses&apos; favorite platforms like
                  {" "}
                  <span className="fw-semi-bold">Slack</span>
                  {", "}
                  <span className="fw-semi-bold">Discord</span>
                  {", "}
                  <span className="fw-semi-bold">Matrix</span>
                  {", "}
                  <span className="fw-semi-bold">PagerDuty</span>
                  {", "}
                  <span className="fw-semi-bold">webhooks</span>
                  {", "}
                  <span className="fw-semi-bold">e-mails</span>
                  {", "}
                  <span className="fw-semi-bold">SMS</span>
                  {", "}
                  and
                  {" "}
                  <span className="fw-semi-bold">phone calls</span>
                  .
                </p>

                <p>Simple and quick setup ensures you&apos;re always informed and ready to respond.</p>
              </div>

              <Link
                className="align-items-center btn btn-outline-primary d-inline-flex gap-2 mt-8"
                target="_blank"
                to="/docs/alerts/introduction?utm-medium=landing"
              >
                <span>Learn to set your alerts</span>
                <IconArrowRight size={20} />
              </Link>
            </div>
          </div>

          <div className="col-12 col-lg-5">
            <IntegrationsWheel className="d-block mx-auto mw-32rem" />
          </div>
        </div>
      </div>
    </section>
  );
}
